__turbopack_context__.v({
  "helios-content-block": "mQmVpa_helios-content-block",
  "helios-content-block--align-center": "mQmVpa_helios-content-block--align-center",
  "helios-content-block--full-height": "mQmVpa_helios-content-block--full-height",
  "helios-content-block--padding-lg": "mQmVpa_helios-content-block--padding-lg",
  "helios-content-block--padding-md": "mQmVpa_helios-content-block--padding-md",
  "helios-content-block--padding-sm": "mQmVpa_helios-content-block--padding-sm",
  "helios-content-block--padding-xl": "mQmVpa_helios-content-block--padding-xl",
  "helios-content-block--rhythm-callout": "mQmVpa_helios-content-block--rhythm-callout",
  "helios-content-block--rhythm-compact": "mQmVpa_helios-content-block--rhythm-compact",
  "helios-content-block--rhythm-default": "mQmVpa_helios-content-block--rhythm-default",
  "helios-content-block--surface-brand": "mQmVpa_helios-content-block--surface-brand",
  "helios-content-block--surface-dark": "mQmVpa_helios-content-block--surface-dark",
  "helios-content-block--surface-subtle": "mQmVpa_helios-content-block--surface-subtle",
  "helios-content-block--surface-transparent": "mQmVpa_helios-content-block--surface-transparent",
  "helios-content-block--tone-inverse": "mQmVpa_helios-content-block--tone-inverse",
});
